<template>
    <div style="position: relative; height: 100%">
        <h1 class="title" style="margin-bottom: 10px; margin-top: 0; padding-top: 20px">
            联系我们
        </h1>
        <div class="mid">
            <div class="left">
                <p>成都千村科技有限责任公司</p>
                <p>
                    地址:
                    中国(四川)自由贸易试验区成都高新区应龙路1199号12栋3层326号
                </p>
                <!-- <p>联系方式: 杨先生 : 18100827257 </p>
                <p> 肖先生 : 18982035290 </p> -->
                <div style="display: flex;" class="plac">
                    <div>联系方式：</div>
                    <div>
                        <div>杨先生 : 18100827257</div>
                        <div>肖先生 : 18982035290</div>
                    </div>
                </div>
                <p>邮编: 610199</p>
                <p>邮箱: marketing@1024tec.com</p>
            </div>
            <div class="right" @wheel="handleMapWheel">
                <el-amap class="map" :center="amapCenter" :zoom="zoom" :scrollWheel="true">
                    <el-amap-control-toolbar position="LT"></el-amap-control-toolbar>
                    <el-amap-marker :position="amapCenter" @click="openInfoWindow"></el-amap-marker>
                    <el-amap-info-window :position="amapCenter" :visible="infoWindowVisible" @close="closeInfoWindow">
                        <div>
                            <p>成都千村科技有限责任公司</p>
                            <p>
                                地址:
                                中国(四川)自由贸易试验区成都高新区应龙路1199号12栋4层401附11号
                            </p>
                            <!-- <p>联系方式: 杨先生 : 18100827257</p> -->
                            <div style="display: flex;" class="plac">
                                <div>联系方式：</div>
                                <div>
                                    <div>杨先生 : 18100827257</div>
                                    <div>肖先生 : 18982035290</div>
                                </div>
                            </div>
                            <p>邮编: 610199</p>
                            <p>邮箱: marketing@1024tec.com</p>
                        </div>
                    </el-amap-info-window>
                </el-amap>
            </div>
        </div>
        <div class="bom">
            成都千村科技有限责任公司 | ICP备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">蜀ICP备20016250号</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 公司地址对应的经纬度（高德为 [lng, lat] 数组）
            amapCenter: [104.095611, 30.535126],
            // 地图初始缩放级别
            zoom: 18,
            // 信息窗口是否显示的标志
            infoWindowVisible: false,
        };
    },

    methods: {
        handleMapWheel(event) {
            // 阻止事件冒泡，防止传播到父组件
            event.stopPropagation();
            // 阻止默认的页面滚动行为
            event.preventDefault();
        },
        openInfoWindow() {
            // 打开信息窗口
            this.infoWindowVisible = true;
        },
        closeInfoWindow() {
            // 关闭信息窗口
            this.infoWindowVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    font-size: 36px;
    color: #fff;
    font-weight: 700;
    margin-left: 40px;
}

.mid {
    height: 60vh;
    width: 70vw;
    margin: auto;
    display: flex;
    justify-content: space-between;

    .left {
        height: 100%;
        width: 35%;
        background-color: transparent;
        line-height: 200%;
        color: #c6caca;

        .plac {
            color: #c6caca;
            margin-bottom: 10px;
            font-size: 0.2rem;
            margin-left: 15px;
            align-items: center;
        }

        p {
            color: #c6caca;
            margin-bottom: 10px;
            font-size: 0.2rem;
            margin-left: 15px;
        }

        p:nth-child(1) {
            font-size: 0.3rem;
            margin-top: 30%;
        }
    }

    .right {
        height: 100%;
        width: 60%;

        .map {
            width: 100%;
            height: 100%;

            .bm-navigation {
                top: 10px;
                left: 10px;
            }
        }
    }
}

.bom {
    height: 20vh;
    width: 100%;
    background-color: #1c3247;
    position: absolute;
    bottom: 0;
    color: #c6caca;
    text-align: center;
    line-height: 20vh;

    a {
        color: #4cd0ea;
        text-decoration: none;
    }

    a:hover {
        color: #2188ff;
    }
}

@media (max-width: 798px) {
    .title {
        text-align: center;
        margin-left: 0;
    }

    .mid {
        display: block;

        .left {
            height: 25%;
            width: 100%;
            line-height: 1.2;
            overflow: hidden;
            background-color: transparent;

            p {
                color: #c6caca;
                margin-bottom: 5px;
                font-size: 9px;
                margin-left: 15px;
                margin-top: 5px;
            }

            .plac {
                color: #c6caca;
                margin-bottom: 5px;
                font-size: 9px;
                margin-left: 15px;
            }

            p:nth-child(1) {
                font-size: 12px;
                margin-top: 15px;
            }
        }

        .right {
            height: 75%;
            width: 100%;
        }
    }

    .bom {
        font-size: 10px;
        text-align: center;
        line-height: 18;
    }
}
</style>